import React from 'react';
import NumberFormat from 'react-number-format';
import {
  Card,
  Grid,
  MenuItem,
  TextField,
  Typography
} from '@material-ui/core';
import { states } from 'helpers/usStates';


const timezones = [
  { name: 'EST – Eastern Standard Time', code: 'EST', timezone: 'America/New_York' },
  { name: 'PST – Pacific Standard Time', code: 'PST', timezone: 'America/Los_Angeles' },
  { name: 'CST – Central Standard Time', code: 'CST', timezone: 'America/Chicago' },
  { name: 'HDT – Hawaii-Aleutian Daylight Time', code: 'HDT', timezone: 'America/Honolulu' },
  { name: 'HST – Hawaii Standard Time', code: 'HST', timezone: 'America/Adak' },
  { name: 'MST – Mountain Standard Time', code: 'MST', timezone: 'America/Phoenix' },
  { name: 'AKDT – Alaska Daylight Time', code: 'AKDT', timezone: 'America/Anchorage' }
];

const StepOne = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue
}) => {
  const {
    storeInformation: {
      firstName,
      lastName,
      storeName,
      website,
      streetAddress1,
      streetAddress2,
      city,
      stateId,
      timezone,
      zipCode,
      phone
    }
  } = values;

  const handleChangeState = (selected, item) => {
    const {children} = item.props;
    const {value} = selected.target;

    setFieldValue('storeInformation.state', children);
    setFieldValue('storeInformation.stateId', value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={3}>
        <Typography variant="h4" component="h4" className="h4 mb-5">
          Account Setup
        </Typography>
        <Typography variant="body1">
          Complete your information and proceed to the next step so we can build your account.
        </Typography>
      </Grid>
      <Grid item xs={12} md={9}>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.firstName"
                label="First Name"
                value={firstName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.firstName && Boolean(errors?.storeInformation?.firstName)}
                helperText={touched?.storeInformation?.firstName && errors?.storeInformation?.firstName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.lastName"
                label="Last Name"
                value={lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.lastName && Boolean(errors?.storeInformation?.lastName)}
                helperText={touched?.storeInformation?.lastName && errors?.storeInformation?.lastName}
              />
            </Grid>
          </Grid>
        </Card>
        <Card elevation={25} className="p-5 mb-5">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.storeName"
                label="Store Name"
                value={storeName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.storeName && Boolean(errors?.storeInformation?.storeName)}
                helperText={touched?.storeInformation?.storeName && errors?.storeInformation?.storeName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                name="storeInformation.website"
                label="Website"
                value={website}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Grid>
          </Grid>
        </Card>
        <Card elevation={25} className="p-5">
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.streetAddress1"
                label="Street Address 1"
                value={streetAddress1}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.streetAddress1 && Boolean(errors?.storeInformation?.streetAddress1)}
                helperText={touched?.storeInformation?.streetAddress1 && errors?.storeInformation?.streetAddress1}
              />
            </Grid>
            <Grid item xs={12} md={6} className="mb-5">
              <TextField
                fullWidth
                variant="outlined"
                name="storeInformation.streetAddress2"
                label="Street Address 2"
                value={streetAddress2}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.city"
                label="City"
                value={city}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.city && Boolean(errors?.storeInformation?.city)}
                helperText={touched?.storeInformation?.city && errors?.storeInformation?.city}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                select
                variant="outlined"
                name="storeInformation.stateId"
                label="State"
                value={stateId}
                onChange={handleChangeState}
                onBlur={handleBlur}
                error={touched?.storeInformation?.stateId && Boolean(errors?.storeInformation?.stateId)}
                helperText={touched?.storeInformation?.stateId && errors?.storeInformation?.stateId}
              >
                {states.map((state) => (
                  <MenuItem key={state.value} value={state.value}>
                    {state.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                variant="outlined"
                name="storeInformation.zipCode"
                label="Zip Code"
                value={zipCode}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.zipCode && Boolean(errors?.storeInformation?.zipCode)}
                helperText={touched?.storeInformation?.zipCode && errors?.storeInformation?.zipCode}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                variant="outlined"
                name="storeInformation.country"
                label="Country"
                value="US"
                onChange={handleChange}
                onBlur={handleBlur}
                inputProps={{ readOnly: true, shrink: 'true' }}
                error={touched?.storeInformation?.country && Boolean(errors?.storeInformation?.country)}
                helperText={touched?.storeInformation?.country && errors?.storeInformation?.country}
              />
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <TextField
                fullWidth
                required
                select
                variant="outlined"
                name="storeInformation.timezone"
                label="Timezone"
                value={timezone}
                onChange={handleChange}
                onBlur={handleBlur}
              >
                {timezones.map((t) => (
                  <MenuItem key={t.code} value={t.timezone}>
                    {t.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4} className="mb-5">
              <NumberFormat
                customInput={TextField}
                format="(###) ###-####"
                mask="_"
                required
                className="w-full"
                label="Phone"
                variant="outlined"
                name="storeInformation.phone"
                value={phone}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched?.storeInformation?.phone && Boolean(errors?.storeInformation?.phone)}
                helperText={touched?.storeInformation?.phone && errors?.storeInformation?.phone}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default StepOne;
